import { FunctionComponent, useState } from 'react';
import styles from "./LocationReviews.module.css";
import cn from 'classnames';
import { Card, Image } from 'react-bootstrap';
import { ASSESTS } from '../../../constant/assest';
import CustomButton, { ButtonType } from '../../common/CustomButton/CustomButton';
import React from 'react';
import LocationReviewModal from './component/LocationReviewModal/LocationReviewModal';

interface ILocationReviewsProps {
    title: string;
    className?: string;
};

const pendingLocationReviewsList = [
    {id: 1, name: 'Crystal Lake', userName: 'ngler_mike23'},
    {id: 2, name: 'Pine River', userName: 'Carl_Fisher'},
    {id: 3, name: 'Hidden Cove', userName: 'Sara Johnson'},
    {id: 4, name: 'Crystal Lake', userName: 'ngler_mike23'},
    {id: 5, name: 'Pine River', userName: 'Carl_Fisher'},
    {id: 6, name: 'Hidden Cove', userName: 'Sara Johnson'},
    {id: 7, name: 'Crystal Lake', userName: 'ngler_mike23'},
    {id: 8, name: 'Pine River', userName: 'Carl_Fisher'},
    {id: 9, name: 'Hidden Cove', userName: 'Sara Johnson'},
    {id: 10, name: 'Crystal Lake', userName: 'ngler_mike23'},
    {id: 11, name: 'Pine River', userName: 'Carl_Fisher'},
    {id: 12, name: 'Hidden Cove', userName: 'Sara Johnson'},
    {id: 14, name: 'Crystal Lake', userName: 'ngler_mike23'},
];

const LocationReviews: FunctionComponent<ILocationReviewsProps> = ({title,  className }) => {
    const [showLocationReview, setShowLocationReview] = useState<boolean>(false)

    const reviewItem = (name: string, userName: string, reviewBtnClick: () => void, approveBtnClick: () => void) => {
        return (
            <div className={styles.reviewItem}>
                <div className={styles.reviewLake}>
                    <Image src={ASSESTS.LOCATIONGREEN} alt={name} width={30} height={30} />
                    <Card.Text as={'div'} bsPrefix={styles.name}>
                        <span className={styles.lakename}>{name}</span> by {userName}
                    </Card.Text>
                </div>
                <div className={styles.reviewAction}>
                    <CustomButton
                        className={cn(styles.lakeBtn, styles.reviewBtn)}
                        btnType={ButtonType.LIGHT}
                        onClick={reviewBtnClick}
                    >
                        Review
                    </CustomButton>
                    <CustomButton
                        className={cn(styles.lakeBtn, styles.approveBtn)}
                        btnType={ButtonType.GREEN}
                        onClick={approveBtnClick}
                    >
                        Approve
                    </CustomButton>
                </div>
            </div>
        );
    };

    return (
        <>
        <Card bsPrefix={cn(styles.locationReviews, className)}>
            <Card.Title as={'div'} bsPrefix={styles.title}>{title} <span className={styles.count}>({pendingLocationReviewsList.length})</span></Card.Title>
            <Card.Body bsPrefix={styles.body}>
                {pendingLocationReviewsList.map((item, idx) => (
                    <React.Fragment key={`${item.id}-${idx}`}>
                        {reviewItem(item.name, item.userName, () => setShowLocationReview(true), () => {})}
                    </React.Fragment>
                ))}
                
            </Card.Body>
        </Card>
        <LocationReviewModal 
            showModal={showLocationReview} 
            onClose={() => setShowLocationReview(false)}
        />
        </>
    );
};

export default LocationReviews;
